import { render } from "./auth-header.vue?vue&type=template&id=9362a938&lang=html"
import script from "./auth-header.vue?vue&type=script&lang=js"
export * from "./auth-header.vue?vue&type=script&lang=js"

import "./auth-header.vue?vue&type=style&index=0&id=9362a938&lang=scss"

import exportComponent from "D:\\Projects\\unistroy\\market\\market-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__